import { TemplatesApp, bootstrapTemplates } from '@desygner/ui-editor-menus';
import React from 'react';
import { constants } from '@config';
import ReactAppBuilder from 'src/utils/react-app-builder';

class TemplatesView extends ReactAppBuilder {
  constructor ({ appId, targetNodeSelector }) {
    super({ appId, targetNodeSelector });

    this.bootstrapApp();
  }

  closeApp () {
    super.closeApp(this.App);
  }

  mountApp () {
    super.mountApp(this.App);
  }

  async bootstrapApp () {
    bootstrapTemplates({
      company: 'desygner',
      token: `Basic ${CONFIG.api_key}`,
      baseUrl: INKIVE.C.API_URL,
      staticsUrl: constants.staticUrl
    });
  }

  #isCanvasMainTagEmpty () {
    return !INKIVE.DesignFacade.get().filter(element => element.id !== 'background').length;
  }

  confirmationModal (data) {
    const addNewPageButton = {
      title: INKIVE.TranslateHelper.translate('modal.title.add_new_page'),
      cls: 'modal-apply-secondary-template',
      onClick: () => {
        localStorage.setItem('modalRestrictedTemplateConfirmDontShowAgain', $('input#dont-show-again').is(':checked'));

        this.modal.close();

        INKIVE.ProjectFacade.handle('design', 'add', { quiet: true })
          .then(() => this.#applyTemplate(data));
      }
    };
    const replacePageButton = {
      title: INKIVE.TranslateHelper.translate('modal.title.replace_current_page'),
      cls: 'modal-apply-secondary-template',
      onClick: () => {
        localStorage.setItem('modalRestrictedTemplateConfirmDontShowAgain', $('input#dont-show-again').is(':checked'));

        this.modal.close();
        this.#applyTemplate(data);
      }
    };

    this.modal = INKIVE.Modal.modalWindow(INKIVE.TemplatesHelper('modal_restricted_template_confirm'), {
      width: 550,
      height: 250,
      headerIcon: 'icon-cloud-download',
      headerTitle: INKIVE.TranslateHelper.translate('modal.title.apply_template'),
      buttons: [
        addNewPageButton,
        replacePageButton
      ]
    });
  }

  #applyTemplate ({ isPremium, projectId, pageId, pageNumber }) {
    INKIVE.DesignFacade.set('template', {
      restricted: {
        id: projectId,
        page_id: pageId,
        page: pageNumber
      }
    });

    INKIVE.Modal.togglePageLoader(false);
  }

  #hasUserRestraints ({ isPremium }) {
    if (!isPremium) return false;

    return !INKIVE.UserInfoFactory.isProPaidUser();
  }

  onTemplateClick (data) {
    INKIVE.Modal.togglePageLoader(true);

    if (this.#hasUserRestraints(data)) {
      return INKIVE.Helpers.displaySubscriptionModal();
    }

    if (this.#isCanvasMainTagEmpty()) {
      this.#applyTemplate(data);
      return;
    }

    this.confirmationModal(data);
  }

  App = () => (
    <TemplatesApp onTemplateClick={this.onTemplateClick.bind(this)} />
  );
}

export default new TemplatesView({
  appId: 'react-templates-app',
  targetNodeSelector: '.tab-content.template .add'
});
